module.exports = __webpack_public_path__ + "static/img/modulo_bluetooth_hc_05-1.d747526.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/modulo_bluetooth_hc_05-1.svg
// module id = J6bH
// module chunks = 0